<template>
  <v-layout row class="align-center">
    <Input
      v-model="inputData"
      placeholder="すべての契約書から条文検索"
      prepend-inner-icon="search"
      width="100%"
      clearable
      @keydown.enter.native="onKeyDown"
      class="py-auto my-auto z-1000"
    />
    <Button :new="isButtonColorNew" :cloudsign="isButtonColorCloudsignReview" height="32" width="150" @click.native="onClick">
      <v-icon size="25" class="mr-6">search</v-icon>
      <SpanText small bold>条文検索</SpanText>
    </Button>
  </v-layout>
</template>
<script>
import Input from '@/components/_atoms/inputs/Input.vue';
import Button from '@/components/_atoms/buttons/Button.vue';
import SpanText from '@/components/_atoms/SpanText.vue';

export default {
  name: 'SearchInputButton',
  components: {
    Input,
    Button,
    SpanText
  },
  props: {
    value: { type: String, required: false, default: '' }
  },
  data() {
    return {
      inputData: this.value,
      isButtonColorNew: true,
      isButtonColorCloudsignReview: false
    };
  },
  computed: {
    isCloudsignReview: function() {
      return this.$store.state.auth.isDispPoweredLabel;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.isCloudsignReview) {
        this.isButtonColorNew = false;
        this.isButtonColorCloudsignReview = true;
      }
    },
    actionSearch() {
      if (!this.inputData || this.inputData.length < 2) {
        this.$store.dispatch('message/setWarningMessage', {
          message: 'キーワードを2文字以上入力してください'
        });
        return;
      }
      this.$emit('search', this.inputData);
    },
    onKeyDown(e) {
      if (e.keyCode !== 13) {
        return;
      }
      this.actionSearch();
    },
    onClick() {
      this.actionSearch();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_molecules/SearchInputButton.vue